import { buttonStyles } from "@components/ui/Button"
import { Icon } from "@components/ui/Icon"
import { tv } from "@utils/tw"
import { AnimatePresence, motion } from "motion/react"
import { PropsWithChildren, ReactNode, startTransition, useState } from "react"

type Props = PropsWithChildren<{
  title?: ReactNode
}>

export function Accordion({ title, children }: Props) {
  const [expanded, setExpanded] = useState(false)
  const styles = createStyles({ expanded })

  return (
    <div className={styles.base()}>
      <div className={styles.header()} onClick={() => !env.admin && startTransition(() => setExpanded(!expanded))}>
        <div className={styles.title()}>{title}</div>
        <button
          className={buttonStyles({ shape: "icon", variant: "ghost", class: "flex-none" })}
          onClick={() => env.admin && startTransition(() => setExpanded(!expanded))}
        >
          <AnimatePresence mode="popLayout">
            <motion.div
              key={expanded ? "expanded" : "collapsed"}
              initial={{ rotate: 90, opacity: 0, scale: 0 }}
              animate={{ rotate: 0, opacity: 1, scale: 1 }}
              exit={{ rotate: -90, opacity: 0, scale: 0 }}
            >
              <Icon name={expanded ? "minus" : "plus"} />
            </motion.div>
          </AnimatePresence>
        </button>
      </div>
      <AnimatePresence>
        {expanded && (
          <motion.div
            className={styles.content()}
            initial={{ height: 0 }}
            animate={{ height: "auto", transition: { type: "spring", stiffness: 180, damping: 20 } }}
            exit={{ height: 0, transition: { duration: 0.2 } }}
          >
            <div className="pt-4 pb-4 border-t border-t-bg-mid">{children}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}

const createStyles = tv({
  base: [
    "group flex flex-col px-3 md:px-4 rounded-md [&_+_&]:outline",
    "border border-bg-mid text-fg",
    "bg-bg text-fg hover:text-fg border border-bg-mid",
    "transition-colors",
    "@md:flex-row @md:items-center @md:justify-between",
    "overflow-hidden",
  ],
  slots: {
    title: "type-ui-l pl-3 md:pl-2",
    header: "flex py-3 md:py-4 items-center justify-between w-full cursor-pointer",
    content: "pt-0 px-2",
  },
  variants: {
    expanded: {
      true: {
        base: "!bg-bg-low",
      },
    },
  },
})
